const HomeIcon = ({ className, fill }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.93651 1.66325C8.63307 1.27236 9.27829 1.04163 10 1.04163C10.7217 1.04163 11.3669 1.27236 12.0635 1.66325C12.7384 2.04198 13.5118 2.60116 14.4843 3.30431L15.7418 4.21357C16.5223 4.77785 17.1456 5.22854 17.6158 5.64569C18.1012 6.0764 18.4644 6.50579 18.6948 7.04591C18.9256 7.5872 18.9815 8.142 18.9505 8.78169C18.9206 9.39901 18.8062 10.1438 18.6634 11.0726L18.4007 12.7822C18.1979 14.1021 18.0364 15.153 17.7991 15.9718C17.5538 16.8184 17.2082 17.4905 16.5905 18.0043C15.9754 18.5159 15.2426 18.7438 14.3475 18.8525C13.4767 18.9583 12.3782 18.9583 10.9908 18.9583H9.00925C7.6218 18.9583 6.52334 18.9583 5.65256 18.8525C4.75743 18.7438 4.02465 18.5159 3.40951 18.0043C2.7918 17.4905 2.44621 16.8184 2.20088 15.9718C1.96363 15.153 1.80214 14.102 1.59932 12.7822L1.33661 11.0726C1.19387 10.1439 1.0794 9.39903 1.04952 8.78169C1.01855 8.142 1.07438 7.5872 1.30525 7.04591C1.53562 6.50579 1.8988 6.0764 2.38425 5.64569C2.85441 5.22854 3.47775 4.77785 4.2582 4.21356L5.51573 3.30433C6.48823 2.60117 7.26159 2.04199 7.93651 1.66325ZM8.01192 13.5091C7.64875 13.2264 7.12516 13.2916 6.84245 13.6548C6.55975 14.018 6.62499 14.5416 6.98816 14.8243C7.8034 15.4588 8.85945 15.8333 10 15.8333C11.1406 15.8333 12.1967 15.4588 13.0119 14.8243C13.3751 14.5416 13.4403 14.018 13.1576 13.6548C12.8749 13.2916 12.3513 13.2264 11.9882 13.5091C11.4709 13.9118 10.7765 14.1667 10 14.1667C9.22356 14.1667 8.52923 13.9118 8.01192 13.5091Z"
        fill={fill || "#0051FF"}
      />
    </svg>
  );
};

export default HomeIcon;
